import { render, staticRenderFns } from "./dyTab.vue?vue&type=template&id=25fb2b56&scoped=true"
import script from "./dyTab.vue?vue&type=script&lang=js"
export * from "./dyTab.vue?vue&type=script&lang=js"
import style0 from "./dyTab.vue?vue&type=style&index=0&id=25fb2b56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb2b56",
  null
  
)

export default component.exports